import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Alert } from 'react-bootstrap';
import { signOutMed } from '../store/modules/auth/doctor/actions';
import { signOutPac } from '../store/modules/auth/patient/actions';
import { signOutFunc } from '../store/modules/auth/funcionario/actions';

const NotAllowed = () => {
  const medico = useSelector(state => state.doctor.profile);
  const { patient } = useSelector(state => state.patient);
  const { funcionario } = useSelector(state => state.funcionario);
  const dispatch = useDispatch();

  function signOut() {
    if (patient) dispatch(signOutPac());
    if (medico) dispatch(signOutMed());
    if (funcionario) dispatch(signOutFunc());
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
      }}
    >
      <Alert variant="danger" className="text-center">
        <h1>Acesso não permitido!</h1>
        <p>Você não tem acesso a esta página.</p>
        <Button onClick={signOut} variant="danger">
          Sair
        </Button>
      </Alert>
    </div>
  );
};

export default NotAllowed;
